import identity from "ramda/es/identity";
import { useCallback } from 'react';
import { setValue } from '../../../stream/transfer/control';
import useControlNext from '../../state/useControlNext';
/**
 * Provides change handler for field
 *
 * @documented
 * @category Field
 * @import import useHandleChange from '@gef-ui/form-core/hooks/field/useHandleChange'
 * @param {Object} input
 * @param {String} input.fieldName
 * @param {Number[]} [input.fieldIndices] - indices for array, can be nested and sorted by path of nesting
 * @param {boolean} [input.validationType]
 * @param {function} [input.modelParser=Identity]
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @returns {Function} handleChange
 * @example
 *
 * 	const handleChange = useHandleChange({fieldName: 'xxx'});
 *
 */ const useHandleChange = ({ fieldName, fieldIndices, validationType, modelParser = identity, forceValue }, formName)=>{
    const next = useControlNext(formName);
    const handleChange = useCallback(// todo tohle by chtelo nekdy refactorovat na objekt
    (e, value, keepPristine, forceValueLocal = forceValue)=>{
        const resolvedValue = modelParser(forceValueLocal ? value : value ?? e.target.value, e);
        next(setValue({
            fieldName,
            value: resolvedValue,
            validationType,
            fieldIndices,
            keepPristine: keepPristine === true
        }));
    }, [
        validationType,
        fieldName,
        fieldIndices,
        next,
        modelParser,
        forceValue
    ]);
    return handleChange;
};
export default useHandleChange;
